import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SettingsIcon from '@mui/icons-material/Settings';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useLocation, useNavigate } from 'react-router-dom';
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from 'react-redux';
import CategoryIcon from '@mui/icons-material/Category';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import { BrandingWatermark, Business, BusinessCenter, CardMembership, Chat, Forum, Image, Kitesurfing, ListAlt, Map, Money, NotificationAdd, NotificationAddTwoTone, Notifications, NotificationsActive, Payment, PermMedia, PostAdd, Settings, Shop, ViewList, Wallet, VideoLibrary, PhotoLibrary, Smartphone, Home, WhatsApp, Folder, ReceiptLong, Assessment, } from '@mui/icons-material';
import GroupIcon from '@mui/icons-material/Group';
import ApprovalIcon from '@mui/icons-material/Approval';
import { useEffect, useState } from 'react';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { usePermission } from '../../hooks/usePermission';

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),

  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(0)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
  [theme.breakpoints.up('lg')]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },

});

export default function Sidebar() {
  const theme = useTheme();
  const [subOrderOpen, setSubOrderOpen] = useState(0);

  const dispatch = useDispatch();

  const updateOpen = () => {
    dispatch({
      type: 'menuStatus'
    })
  };
  const open = useSelector(state => state.utilsSto.menu);
  const navigate = useNavigate();
  const activeMenu = useSelector(state => state.utilsSto.menuDefaultSelected);

  const handleNavigation = (path) => {
    setSubOrderOpen(0);
    navigate(path);
  }
  const pathUrl = useLocation().pathname;
  useEffect(() => {
    if (pathUrl.startsWith('/settings')) {
      setSubOrderOpen(1);
    } else if (pathUrl.startsWith('/marketing')) {
      setSubOrderOpen(2);
    } else if (pathUrl.startsWith('/testing')) {
      setSubOrderOpen(3);
    }else if (pathUrl.startsWith('/admin/booking') ) {
      setSubOrderOpen(4);
    } else if (pathUrl.startsWith('/notification')) {
      setSubOrderOpen(5);
    }else if (pathUrl.startsWith('/admin/users')) {
      setSubOrderOpen(6);
    } else if (pathUrl.startsWith('/admin/media')) {
      setSubOrderOpen(7);
    } else if (pathUrl.startsWith('/customer-app')) {
      setSubOrderOpen(8);
    } else if (pathUrl.startsWith('/admin/report')) {
      setSubOrderOpen(9);
    }
    else {
      setSubOrderOpen(0);
    }
  }, [pathUrl])

  /******************  permission checking*******************/
  const bookingPermission = usePermission("booking");
  const servicePermission = usePermission("service");
  const userPermission = usePermission("service-expert");
  const categoryPermission = usePermission("category");
  const customerPermission = usePermission("customer");
  const systemSettingPermission = usePermission("system-setting");
  const rolePermission = usePermission("roles-and-permissions");
  const rewardProgramPermission = usePermission("reward-program");
  const adminMemberPermission = usePermission("register-admin");
  const bannerPermission = usePermission("banner");
  const couponPermission = usePermission("coupon");
  const abandonCartPermission = usePermission("abandon-cart");
  const marketingPermission = usePermission("marketing");
  const notificationPermission = usePermission("notification");
  const brandPermission = usePermission("brand");
  const testingPermission = usePermission('testing');
  const lynsPermission = usePermission('lyns');
  const chatPermission = usePermission('chats');
  const mediaPermission = usePermission('media');
  const bookingPaymentPermission = usePermission('booking-payment');
  const subscriptionPermission = usePermission('subscription');
  const expertWalletPermission = usePermission('expert-wallet-management');
  const customerAppPermission = usePermission('customer-app');
  const whatsappLogPermission = usePermission('whatsapp-log');
  const enumSettingsPermission = usePermission('enum-settings');
  const reportPermission = usePermission('reports');
  const taxReportPermission = usePermission('tax-report');

  return (
    <Box sx={{ display: 'flex' }} mt={2}>
      <CssBaseline />
      <Drawer variant="permanent" open={open}
        // sx={{ color: '#f00' ,
        //   '& .MuiDrawer-paper': {
        //     width: open && '14vw',
        //   }
        // }}
        sx={{
          width: '14vw', // Set the overall drawer width
          color: '#f00',
          '& .MuiDrawer-paper': {
            width: open ? '14vw' : theme.spacing(7), // Dynamic width
            transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms'
          }
        }}
      >
        <DrawerHeader />
        {/* </DrawerHeader> */}
        <List>
          {/* ----Dashboard----- */}
          <ListItem
            disablePadding
            onClick={() => {
              handleNavigation("/admin");
              
            }}
            sx={{ display: 'block' }}
            selected={activeMenu === "home"}
          >
            <ListItemButton
              sx={{
                minHeight: 30,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
                py: 0.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 1 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <HomeIcon sx={{ fontSize: '1.25rem' }} />
              </ListItemIcon>
              <ListItemText primary="Dashboard" sx={{
                opacity: open ? 1 : 0, '& .MuiTypography-root': {
                  fontSize: '.75rem'
                }
              }} />
            </ListItemButton>
          </ListItem>

          {/* ----Bookings----- */}

          {/* {(role != '0') && ( */}
          {/* {bookingPermission.canView &&
            <ListItem
              disablePadding
              selected={activeMenu === "bookings"}
              onClick={() => {
                handleNavigation("/admin/booking");
                
              }}
              sx={{ display: 'block' }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <Business fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Bookings" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />
              </ListItemButton>
            </ListItem>
          } */}

          {/* ============= Booking list And Chats ============ */}
          {bookingPermission.canView && 
            <ListItem
              disablePadding
              
              onClick={() => {
                setSubOrderOpen((subOrderOpen!=0 &&subOrderOpen == 4) ? 0 : 4);
                
                
              }}
              sx={{
                display: 'block',
                bgcolor: subOrderOpen==4 && 'lightGray'
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <Business fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Booking" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />

                {(subOrderOpen ==4) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
              </ListItemButton>
            </ListItem>
          }
          
          <Collapse in={subOrderOpen ==4} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* new notification module section */}
              {bookingPermission.canView &&
                <ListItem
                  disablePadding
                  // selected={activeMenu === "bookings"}
                  onClick={() => {
                    navigate("/admin/booking");
                    
                  }}
                  sx={{ display: 'block',bgcolor:'none' }}
                >
                  <ListItemButton
                    selected={activeMenu === "bookings"}
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                      // Apply selected styles only to button
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                        '&:hover': {
                          backgroundColor: 'rgba(25, 118, 210, 0.12)',
                        }
                      }
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <ListAlt fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Booking List" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
               }
               {bookingPermission.canCreate &&
                <ListItem
                  disablePadding
                  // selected={activeMenu === "bookings"}
                  onClick={() => {
                    navigate("/admin/booking/new");
                    
                  }}
                  sx={{ display: 'block',bgcolor:'none' }}
                >
                  <ListItemButton
                    selected={activeMenu === "create-booking"}
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                      // Apply selected styles only to button
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                        '&:hover': {
                          backgroundColor: 'rgba(25, 118, 210, 0.12)',
                        }
                      }
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <PostAdd fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="New Booking" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
               }
               {/* ============= Booking Payment =============== */}
               {bookingPaymentPermission.canView &&
                <ListItem
                  disablePadding
                  onClick={() => {
                    navigate("/admin/booking/payment");
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    selected={activeMenu === "booking-payment"}
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                      // Apply selected styles only to button
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                        '&:hover': {
                          backgroundColor: 'rgba(25, 118, 210, 0.12)',
                        }
                      }
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <Payment fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Payment" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
               }
               {/* All chats related to bookings */}
               {chatPermission.canView &&
                <ListItem
                  disablePadding
                  // selected={activeMenu === "chats"}
                  onClick={() => {
                    navigate("/admin/booking/chats");
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    selected={activeMenu === "chats"}
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                      // Apply selected styles only to button
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                        '&:hover': {
                          backgroundColor: 'rgba(25, 118, 210, 0.12)',
                        }
                      }
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <Chat fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Chats" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
               }
               
            </List>
          </Collapse>
          {/* )} */}

          {/* ----Customers----- */}

          {/* {(role != '0') && ( */}
          {customerPermission.canView &&
            <ListItem
              disablePadding
              selected={activeMenu === "customer"}
              onClick={() => {
                handleNavigation("/admin/customers");
                
              }}
              sx={{ display: 'block' }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <SupervisedUserCircleIcon fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Customers" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />
              </ListItemButton>
            </ListItem>
          }
          {/* )} */}

          {/* --------------Brand------------- */}

          {brandPermission.canView &&
            <ListItem
              disablePadding
              selected={activeMenu === "brand"}
              onClick={() => {
                handleNavigation("/admin/brand");
                
              }}
              sx={{ display: 'block' }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <BrandingWatermark fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Brand" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />
              </ListItemButton>
            </ListItem>
          }

          {/* ----Categories----- */}

          {/* {(role != '0') && ( */}
          {categoryPermission.canView &&
            <ListItem
              disablePadding
              selected={activeMenu === "category"}
              onClick={() => {
                handleNavigation("/admin/category");
                
              }}
              sx={{ display: 'block' }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <CategoryIcon fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Category" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />
              </ListItemButton>
            </ListItem>
          }
          {/* )} */}

          {/* ----Master services----- */}

          {/* {(role != '0') && ( */}
          {servicePermission.canView &&
            <ListItem
              disablePadding
              selected={activeMenu === "service"}
              onClick={() => {
                handleNavigation("/admin/services");
                
              }}
              sx={{ display: 'block' }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <ShoppingCartIcon fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Master Services" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />
              </ListItemButton>
            </ListItem>
          }
          {/* // )} */}


          {/* ----Service Experts----- */}

          {userPermission.canView && 
            <ListItem
              disablePadding
              
              onClick={() => {
                setSubOrderOpen((subOrderOpen!=0 &&subOrderOpen == 6) ? 0 : 6);
                
                
              }}
              sx={{
                display: 'block',
                bgcolor: subOrderOpen==6 && 'lightGray'
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <PeopleIcon fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Service Experts" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />

                {(subOrderOpen ==6) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
              </ListItemButton>
            </ListItem>
          }
          
          <Collapse in={subOrderOpen ==6} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* new notification module section */}
              {userPermission.canView &&
                <ListItem
                  disablePadding
                  // selected={activeMenu === "bookings"}
                  onClick={() => {
                    navigate("/admin/users");
                    
                  }}
                  sx={{ display: 'block',bgcolor:'none' }}
                >
                  <ListItemButton
                    selected={activeMenu === "user"}
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                      // Apply selected styles only to button
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                        '&:hover': {
                          backgroundColor: 'rgba(25, 118, 210, 0.12)',
                        }
                      }
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <ListAlt fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Expert List" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
               }
               {expertWalletPermission.canCreate &&
                <ListItem
                  disablePadding
                  // selected={activeMenu === "bookings"}
                  onClick={() => {
                    navigate("/admin/users/wallet");
                    
                  }}
                  sx={{ display: 'block',bgcolor:'none' }}
                >
                  <ListItemButton
                    selected={activeMenu === "expert-wallet"}
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                      // Apply selected styles only to button
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                        '&:hover': {
                          backgroundColor: 'rgba(25, 118, 210, 0.12)',
                        }
                      }
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <Wallet fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Expert Wallet" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
               }
               
               
            </List>
          </Collapse>

          {/* {(role == '1') && ( */}
          {/* {userPermission.canView &&
            <ListItem
              disablePadding
              selected={activeMenu === "user"}
              onClick={() => {
                handleNavigation("/admin/users");
                
              }}
              sx={{ display: 'block' }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <PeopleIcon fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Service Experts" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />
              </ListItemButton>
            </ListItem>
          } */}
          {/* // )} */}

          {/* ============= Settings =========== */}
          {/* ========menu options with submenu========== */}

          {systemSettingPermission.canView &&
            <ListItem
              disablePadding
              
              onClick={() => {
                setSubOrderOpen((subOrderOpen != 0 && subOrderOpen == 1) ? 0 : 1);
                // setCollapseOpen(1);
                
              }}
              sx={{
                display: 'block',
                bgcolor: subOrderOpen==1 && 'lightGray'
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <SettingsIcon fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Settings" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />

                {(subOrderOpen  == 1) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
              </ListItemButton>
            </ListItem>
          }
          <Collapse in={subOrderOpen ==1} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* member section */}
              {adminMemberPermission.canView &&
                <ListItem
                  disablePadding
                  selected={activeMenu === "members"}
                  onClick={() => {
                    navigate("/settings/members");
                    
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <GroupIcon fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Members" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
              }
              {/* feature section */}
              <ListItem
                disablePadding
                selected={activeMenu === "features"}
                onClick={() => {
                  navigate("/settings/features");
                  
                }}
                sx={{ display: 'block' }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 30,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                    py: 0.5,
                    marginLeft: 2, // Set the left margin here

                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <ApprovalIcon fontSize='1.25rem' />
                  </ListItemIcon>
                  <ListItemText primary="Features" sx={{
                    opacity: open ? 1 : 0, '& .MuiTypography-root': {
                      fontSize: '.7rem'
                    }
                  }} />
                </ListItemButton>
              </ListItem>

              {/* roles section */}
              {rolePermission.canView &&
                <ListItem
                  disablePadding
                  selected={activeMenu === "roles"}
                  onClick={() => {
                    navigate("/settings/roles");
                    
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <GroupIcon sx={{ fontSize: '1.25rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Roles" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
              }
             

              
              {/* Business section */}
              {/* { bannerPermission.canView && */}
              <ListItem
                disablePadding
                selected={activeMenu === "business"}
                onClick={() => {
                  navigate("/settings/business");
                  
                }}
                sx={{ display: 'block' }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 30,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                    py: 0.5,
                    marginLeft: 2,
                  }}
                >
                  
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    
                    <BusinessCenter sx={{ fontSize: '1.25rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Business" sx={{
                    opacity: open ? 1 : 0, '& .MuiTypography-root': {
                      fontSize: '.7rem'
                    }
                  }} />
                </ListItemButton>
              </ListItem>
              {/* }  */}
              {/* subscription section */}
              {subscriptionPermission.canView &&
                <ListItem
                  disablePadding
                  selected={activeMenu === "subscription"}
                  onClick={() => {
                    navigate("/settings/subscription");
                    
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <CardMembership sx={{ fontSize: '1.25rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Subscription" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
              }
              <ListItem
                disablePadding
                selected={activeMenu === "materialize-view"}
                onClick={() => {
                  navigate("/settings/materialize-view");
                  
                }}
                sx={{ display: 'block' }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 30,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                    py: 0.5,
                    marginLeft: 2,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <ViewList sx={{ fontSize: '1.25rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Materialize View" sx={{
                    opacity: open ? 1 : 0, '& .MuiTypography-root': {
                      fontSize: '.7rem'
                    }
                  }} />
                </ListItemButton>
              </ListItem>

            </List>
          </Collapse>

          {/* ============= Marketings ============ */}
          {marketingPermission.canView && 
          <ListItem
            disablePadding
            
            onClick={() => {
              setSubOrderOpen((subOrderOpen!=0 &&subOrderOpen == 2) ? 0 : 2);
              
              
            }}
            sx={{
              display: 'block',
              bgcolor: subOrderOpen==2 && 'lightGray'
            }}
          >
            <ListItemButton
              sx={{
                minHeight: 30,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
                py: 0.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 1 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <Shop fontSize='1.25rem' />
              </ListItemIcon>
              <ListItemText primary="Marketing" sx={{
                opacity: open ? 1 : 0, '& .MuiTypography-root': {
                  fontSize: '.75rem'
                }
              }} />
              {(subOrderOpen ==2) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
            </ListItemButton>
          </ListItem>
          }
          <Collapse in={subOrderOpen ==2} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* member section */}
              {couponPermission.canView &&
                <ListItem
                  disablePadding
                  selected={activeMenu === "coupons"}
                  onClick={() => {
                    navigate("/marketing/coupons");
                    
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <Money fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Coupons" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
               }
               
              {/* abandoned-cart */}
              {abandonCartPermission.canView &&
                <ListItem
                  disablePadding
                  selected={activeMenu === "abandoned-cart"}
                  onClick={() => {
                    navigate("/marketing/abandoned-cart");
                    
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <ShoppingCartIcon fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Abandoned Cart" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
              }
              {/* banner section */}
              {bannerPermission.canView &&
                <ListItem
                  disablePadding
                  selected={activeMenu === "banners"}
                  onClick={() => {
                    navigate("/marketing/banners");
                    
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <Image sx={{ fontSize: '1.25rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Banners" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
              }
               {/* reward program section */}
              {rewardProgramPermission.canView &&
                <ListItem
                  disablePadding
                  selected={activeMenu === "wallet-reward"}
                  onClick={() => {
                    navigate("/marketing/reward-programs");
                    
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <EmojiEventsIcon sx={{ fontSize: '1.25rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Reward Programs" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
              }
            </List>
          </Collapse>

          {/* ============= Notification ============ */}
          {notificationPermission.canView && 
            <ListItem
              disablePadding
              onClick={() => {
                setSubOrderOpen((subOrderOpen!=0 &&subOrderOpen == 5) ? 0 : 5);
              }}
              sx={{
                display: 'block',
                bgcolor: subOrderOpen==5 && 'lightGray'
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <NotificationsActive fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Notification" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />

                {(subOrderOpen ==5) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
              </ListItemButton>
            </ListItem>
          }
          
          <Collapse in={subOrderOpen ==5} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* new notification module section */}
              {notificationPermission.canView &&
                <ListItem
                  disablePadding
                  selected={activeMenu === "notifications"}
                  onClick={() => {
                    navigate("/notification");
                    
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <NotificationAddTwoTone fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Notification_New" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
               }
               {/* notification */}
              {notificationPermission.canView &&
                <ListItem
                  disablePadding
                  selected={activeMenu === "notification"}
                  onClick={() => {
                    navigate("/notification/old");
                    
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <Notifications fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Notification_Old" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
              }
              {/* Notification Enum Setting */}
              {enumSettingsPermission.canView &&
               <ListItem
                  disablePadding
                  selected={activeMenu === "notificationEnumSetting"}
                  onClick={() => {
                    navigate("/notification/enum-settings");
                    
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <Settings fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Enum Setting" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
              }
              {/* Whatsapp Notification Log */}
              {
                whatsappLogPermission.canView &&
                <ListItem
                  disablePadding
                  selected={activeMenu === "whatsappLog"}
                  onClick={() => {
                    navigate("/notification/whatsapp/log");
                    
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      
                      <WhatsApp fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="WhatsApp Log" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
              }
               
            </List>
          </Collapse>

          {/* ============= Testing ============ */}
          {/* {testingPermission.canView && 
            <ListItem
              disablePadding
              onClick={() => {
                setSubOrderOpen((subOrderOpen!=0 &&subOrderOpen == 3) ? 0 : 3);
              }}
              sx={{
                display: 'block',
                bgcolor: subOrderOpen==3 && 'lightGray'
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <Kitesurfing fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Testing" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />
                {(subOrderOpen ==3) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />}
              </ListItemButton>
            </ListItem>
          } 
          <Collapse in={subOrderOpen ==3} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {notificationPermission.canView &&
                <ListItem
                  disablePadding
                  selected={activeMenu === "notifications"}
                  onClick={() => {
                    navigate("/testing/notification");
                  }}
                  sx={{ display: 'block' }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <NotificationAddTwoTone fontSize='1.25rem' />
                    </ListItemIcon>
                    <ListItemText primary="Notification" sx={{
                      opacity: open ? 1 : 0, '& .MuiTypography-root': {
                        fontSize: '.7rem'
                      }
                    }} />
                  </ListItemButton>
                </ListItem>
               }
            </List>
          </Collapse> */}

          {/* lyns Related */}
          {lynsPermission.canView &&
            <ListItem
              disablePadding
              selected={activeMenu === "lyns"}
              onClick={() => {
                handleNavigation("/lyns");
                
              }}
              sx={{ display: 'block' }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <Forum fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Lyns" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />
              </ListItemButton>
            </ListItem>
          }

          {/* Media Management */}
          {mediaPermission.canView &&
            <>
              <ListItem
                disablePadding
                onClick={() => setSubOrderOpen((subOrderOpen != 0 && subOrderOpen == 7) ? 0 : 7)}
                sx={{ display: 'block', bgcolor: subOrderOpen==7 && 'lightGray' }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 30,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                    py: 0.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <PermMedia fontSize='1.25rem' />
                  </ListItemIcon>
                  <ListItemText primary="Media" sx={{
                    opacity: open ? 1 : 0, '& .MuiTypography-root': {
                      fontSize: '.75rem'
                    }
                  }} />
                  {open && ((subOrderOpen == 7) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />)}
                </ListItemButton>
              </ListItem>

              <Collapse in={subOrderOpen == 7} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {/* All Media files */}
                  <ListItem
                    disablePadding
                    selected={activeMenu === "media-all"}
                    onClick={() => handleNavigation("/admin/media/all")}
                    sx={{ display: 'block' }}
                  >
                    <ListItemButton sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2
                    }}>
                      <ListItemIcon sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}>
                        <Folder fontSize='1.25rem' />
                      </ListItemIcon>
                      <ListItemText primary="All Media" sx={{
                        opacity: open ? 1 : 0, '& .MuiTypography-root': {
                          fontSize: '.7rem'
                        }
                      }} />
                    </ListItemButton>
                  </ListItem>
                  {/* Video */}
                  <ListItem
                    disablePadding
                    selected={activeMenu === "media-video"}
                    onClick={() => handleNavigation("/admin/media/video")}
                    sx={{ display: 'block' }}
                  >
                    <ListItemButton sx={{
                      minHeight: 30,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                      py: 0.5,
                      marginLeft: 2
                    }}>
                      <ListItemIcon sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                      }}>
                        <VideoLibrary fontSize='1.25rem' />
                      </ListItemIcon>
                      <ListItemText primary="Video" sx={{
                        opacity: open ? 1 : 0, '& .MuiTypography-root': {
                          fontSize: '.7rem'
                        }
                      }} />
                    </ListItemButton>
                  </ListItem>
                  
                </List>
              </Collapse>
            </>
          }

          {/* Customer App */}
          <ListItem
            disablePadding
            onClick={() => setSubOrderOpen((subOrderOpen != 0 && subOrderOpen == 8) ? 0 : 8)}
            sx={{ display: 'block', bgcolor: subOrderOpen==8 && 'lightGray' }}
          >
            <ListItemButton
              sx={{
                minHeight: 30,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
                py: 0.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 1 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <Smartphone fontSize='1.25rem' />
              </ListItemIcon>
              <ListItemText primary="App Setting" sx={{
                opacity: open ? 1 : 0, '& .MuiTypography-root': {
                  fontSize: '.75rem'
                }
              }} />
              {open && ((subOrderOpen == 8) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />)}
            </ListItemButton>
          </ListItem>

          <Collapse in={subOrderOpen == 8} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                disablePadding
                selected={activeMenu === "home-screen"}
                onClick={() => handleNavigation("/customer-app/home-screen")}
                sx={{ display: 'block' }}
              >
                <ListItemButton sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                  marginLeft: 2
                }}>
                  <ListItemIcon sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}>
                    <Home fontSize='1.25rem' />
                  </ListItemIcon>
                  <ListItemText primary="Customer Home Screen" sx={{
                    opacity: open ? 1 : 0, '& .MuiTypography-root': {
                      fontSize: '.7rem'
                    }
                  }} />
                </ListItemButton>
              </ListItem>
            </List>
          </Collapse>

          {/* Report */}
          {reportPermission.canView &&
            <ListItem
              disablePadding
              onClick={() => setSubOrderOpen((subOrderOpen != 0 && subOrderOpen == 9) ? 0 : 9)}
              sx={{ display: 'block', bgcolor: subOrderOpen==9 && 'lightGray' }}
            >
              <ListItemButton
                sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <Assessment fontSize='1.25rem' />
                </ListItemIcon>
                <ListItemText primary="Cudel Reports" sx={{
                  opacity: open ? 1 : 0, '& .MuiTypography-root': {
                    fontSize: '.75rem'
                  }
                }} />
                {open && ((subOrderOpen == 9) ? <ExpandLess fontSize='1.25rem' /> : <ExpandMore fontSize='1.25rem' />)}
              </ListItemButton>
            </ListItem>
          }
          <Collapse in={subOrderOpen == 9} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* Tax Report */}
              {taxReportPermission.canView &&
              <ListItem
                disablePadding
                selected={activeMenu === "tax-report"}
                onClick={() => handleNavigation("/admin/report/tax-report")}
                sx={{ display: 'block' }}
              >
                <ListItemButton sx={{
                  minHeight: 30,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  py: 0.5,
                  marginLeft: 2
                }}>
                  <ListItemIcon sx={{
                    minWidth: 0,
                    mr: open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}>
                    <ReceiptLong fontSize='1.25rem' />
                  </ListItemIcon>
                  <ListItemText primary="Tax Report" sx={{
                    opacity: open ? 1 : 0, '& .MuiTypography-root': {
                      fontSize: '.7rem'
                    }
                  }} />
                </ListItemButton>
              </ListItem>
              }
            </List>
          </Collapse>


        </List>

      </Drawer>
    </Box>
  );
}